// extracted by mini-css-extract-plugin
export default {"base":"Bullets_base__QHfhW","dot":"Bullets_dot__pT6Wp","filled":"Bullets_filled__JTeNB","nomatch":"Bullets_nomatch__3Ic0p"};